import { serviceHelper } from '../utils/serviceHelper'

export const getUserByCpf = async (document) => {
  const userApi = getAxiosCreate()
  const { data } = await userApi.get(`/users/cpf/${document}`)
  return data
}

export const getUserByNameOrCPF = async (userNameOrCPF, from = '0', to = '8') => {
  const userApi = getAxiosCreate()
  const res = await userApi.get(`/users/?name=${userNameOrCPF.trim()}&from=${from}&to=${to}&findGuests=false`)
  return res.data
}

export const getUserByEmail = async (userEmail) => {
  const userApi = getAxiosCreate()
  if (userEmail !== '') {
    const user = await userApi.get(`/users/${userEmail.trim()}`)
    return [user.data]
  }
  return null
}

export const createTutor = async (payload) => {
  const userApi = getAxiosCreate()
  if (payload.email) {
    const data = await userApi.post('/users', payload)
    return data
  }
  return null
}

export const updateTutor = async ({ id, payload }) => {
  const userApi = getAxiosCreate()
  const data = await userApi.put(`/users/${id}`, payload)
  return data
}

const getAxiosCreate = () => {
  return serviceHelper.createApiClient(`${process.env.REACT_APP_USER_URL}`)
}
